/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["displayObject", "items", "nav", "options", "rtl", "theme"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import T from 'prop-types';
import _isFunction from 'lodash/isFunction';
import { Carousel } from '@accedo/vdkweb-carousel';
import { updatePrefix } from '../utils/utils';
import withOnlyUpdateKeys from '../utils/withOnlyUpateKeys';
var createId = function createId(_ref) {
  var prefix = _ref.prefix,
    index = _ref.index,
    shift = _ref.shift;
  return "".concat(prefix).concat(index + shift);
};

/**
 * Create nextleft and nextright based on: positioning, infinite and rtl
 * positioning and infinite helps to calcuate next and prev items and rtl
 * defined which one applies to nextright and nextleft based on directionality
 *
 * @param {Object} param Object
 * @param {number} param.index Current item index
 * @param {number} param.dataLength Number of items in the List/Carousel
 * @param {string} param.firstNavId First nav identifier of the List
 * @param {string} param.lastNavId Last nav identifier of the List
 * @param {string} param.prefix nav prefix
 * @param {boolean} param.rtl Whether carousel is infinite or not
 * @param {boolean} param.infinite Whether carousel is infinite or not
 *
 * @returns {Object} { nextright, nextleft}
 */
var calculateNavItems = function calculateNavItems(_ref2) {
  var index = _ref2.index,
    dataLength = _ref2.dataLength,
    firstNavId = _ref2.firstNavId,
    lastNavId = _ref2.lastNavId,
    prefix = _ref2.prefix,
    rtl = _ref2.rtl,
    infinite = _ref2.infinite;
  var nextItem =
  // eslint-disable-next-line no-nested-ternary
  index < dataLength - 1 ? createId({
    prefix: prefix,
    index: index,
    shift: 1
  }) : infinite ? firstNavId : '';
  var previousItem =
  // eslint-disable-next-line no-nested-ternary
  index > 0 ? createId({
    prefix: prefix,
    index: index,
    shift: -1
  }) : infinite ? lastNavId : '';
  var nextright = rtl ? previousItem : nextItem;
  var nextleft = rtl ? nextItem : previousItem;
  return {
    nextright: nextright,
    nextleft: nextleft
  };
};
var buildDisplayObject = function buildDisplayObject(_ref3) {
  var DisplayObject = _ref3.dObj,
    infinite = _ref3.infinite,
    rtl = _ref3.rtl;
  return function (_ref4) {
    var item = _ref4.item,
      prefix = _ref4.prefix,
      dataLength = _ref4.dataLength,
      parentNavId = _ref4.parentNavId,
      _onFocus = _ref4.onFocus,
      _onClick = _ref4.onClick,
      _onBlur = _ref4.onBlur,
      checkNavigateBlock = _ref4.checkNavigateBlock;
    var index = item.__index;
    var navId = createId({
      prefix: prefix,
      index: index,
      shift: 0
    });
    var firstNavId = "".concat(prefix, "0");
    var lastNavId = "".concat(prefix).concat(dataLength - 1);
    var _calculateNavItems = calculateNavItems({
        dataLength: dataLength,
        rtl: rtl,
        infinite: infinite,
        firstNavId: firstNavId,
        lastNavId: lastNavId,
        prefix: prefix,
        index: index
      }),
      nextright = _calculateNavItems.nextright,
      nextleft = _calculateNavItems.nextleft;
    var props = {
      key: navId,
      nav: {
        id: navId,
        parent: parentNavId,
        nextleft: nextleft,
        nextright: nextright,
        internal: {
          nextleft: checkNavigateBlock,
          nextright: checkNavigateBlock
        }
      },
      data: item,
      onFocus: function onFocus() {
        return _onFocus(index);
      },
      onBlur: function onBlur() {
        return _onBlur(index);
      },
      onClick: function onClick() {
        return _onClick(item, index);
      }
    };
    return /*#__PURE__*/React.cloneElement(DisplayObject, props);
  };
};
var FocusHeroCarousel = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FocusHeroCarousel, _React$PureComponent);
  var _super = _createSuper(FocusHeroCarousel);
  function FocusHeroCarousel() {
    var _this;
    _classCallCheck(this, FocusHeroCarousel);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty(_assertThisInitialized(_this), "onBeforeChange", function () {
      _this.blockNavigate = true;
      var options = _this.props.options;
      if (options.beforeChange) {
        options.beforeChange.apply(options, arguments);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onAfterChange", function () {
      var _ref5 = _this.props || {},
        options = _ref5.options;
      if (_isFunction(options.afterChange)) {
        options.afterChange.apply(options, arguments);
      }

      // Unblock navigation if animation is done
      _this.blockNavigate = false;
    });
    _defineProperty(_assertThisInitialized(_this), "childOnBlur", function (index) {
      // Validate if item is cloned so we don't get a blur after the next item onFocus due to cloned items
      if (index !== _this.currentChildIndex && _this.lastBlurIndex === index) {
        return;
      }
      _this.lastBlurIndex = index;

      // Leaving HeroBanner, release navigation block and start autoplay if valid
      if (!_this.blockNavigate) {
        _this.startAutoPlay();
      }
      _this.blockNavigate = false;
    });
    _defineProperty(_assertThisInitialized(_this), "childOnFocus", function (index) {
      _this.currentChildIndex = index;
      clearTimeout(_this.focusOnItemTimer);
      clearTimeout(_this.autoPlayTimer);
      _this.focusOnItemTimer = setTimeout(function () {
        var _assertThisInitialize = _assertThisInitialized(_this),
          _carousel = _assertThisInitialize._carousel,
          lastFocusedSlideIndex = _assertThisInitialize.lastFocusedSlideIndex,
          _assertThisInitialize2 = _assertThisInitialize.props,
          items = _assertThisInitialize2.items,
          options = _assertThisInitialize2.options,
          rtl = _assertThisInitialize2.rtl;
        var lastItemIndex = items.length - 1;
        var realIndex = rtl ? lastItemIndex - index : index;

        // Fix the animation issue for center mode (infinite) hero banner
        if (!(options !== null && options !== void 0 && options.infinite)) {
          _carousel.slickGoTo(realIndex);
        } else if (lastFocusedSlideIndex === undefined) {
          // initial stage, no change
          _carousel.slickGoTo(realIndex);
        } else if (realIndex === 0 && lastFocusedSlideIndex === lastItemIndex) {
          // call slick next instead for last item -> first item
          if (rtl) {
            _carousel.slickPrev();
          } else {
            _carousel.slickNext();
          }
        } else if (lastFocusedSlideIndex === 0 && realIndex === lastItemIndex) {
          // call slick prev instead for first item -> last item
          if (rtl) {
            _carousel.slickNext();
          } else {
            _carousel.slickPrev();
          }
        } else {
          _carousel.slickGoTo(realIndex);
        }
        _this.lastFocusedSlideIndex = realIndex;
      }, _this.props.options.speed || 300);
    });
    return _this;
  }
  _createClass(FocusHeroCarousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startAutoPlay();
    }
  }, {
    key: "startAutoPlay",
    value: function startAutoPlay() {
      var _this2 = this;
      var _this$props = this.props,
        options = _this$props.options,
        rtl = _this$props.rtl;
      if (!options.autoplay) {
        return;
      }
      clearTimeout(this.autoPlayTimer);
      this.autoPlayTimer = setTimeout(function () {
        if (_this2._carousel) {
          if (rtl) {
            _this2._carousel.slickPrev();
          } else {
            _this2._carousel.slickNext();
          }
        }
        _this2.startAutoPlay();
      }, options.autoplaySpeed);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        dObj = _this$props2.displayObject,
        items = _this$props2.items,
        nav = _this$props2.nav,
        options = _this$props2.options,
        rtl = _this$props2.rtl,
        theme = _this$props2.theme,
        otherProps = _objectWithoutProperties(_this$props2, _excluded);
      var _dObj$props = dObj.props,
        itemWidth = _dObj$props.width,
        itemHeight = _dObj$props.height,
        _dObj$props$onClick = _dObj$props.onClick,
        onClick = _dObj$props$onClick === void 0 ? function () {} : _dObj$props$onClick;
      var DisplayObject = buildDisplayObject({
        dObj: dObj,
        infinite: options.infinite,
        rtl: rtl
      });
      var firstVisibleSlide = rtl ? items.length - 1 : 0;
      var prefix = updatePrefix(this);
      return /*#__PURE__*/React.createElement(Carousel, _extends({}, otherProps, {
        displayObject: /*#__PURE__*/React.createElement(DisplayObject, {
          checkNavigateBlock: function checkNavigateBlock() {
            return _this3.blockNavigate;
          },
          dataLength: items.length,
          onBlur: this.childOnBlur,
          onClick: onClick,
          onFocus: this.childOnFocus,
          parentNavId: nav.id,
          prefix: prefix
        }),
        items: items.map(function (c, i) {
          return _objectSpread({
            __index: i
          }, c);
        }),
        options: _objectSpread(_objectSpread({}, options), {}, {
          // We handle autoplay from componenet rather than using slick's
          autoplay: false,
          currentSlide: firstVisibleSlide,
          itemWidth: itemWidth,
          itemHeight: itemHeight,
          // using default slick-dots class + custom css
          dotsClass: "slick-dots ".concat((options === null || options === void 0 ? void 0 : options.dotsClass) || ''),
          beforeChange: this.onBeforeChange,
          afterChange: this.onAfterChange,
          ref: function ref(c) {
            _this3._carousel = c;
          },
          rtl: rtl
        })
      }));
    }
  }]);
  return FocusHeroCarousel;
}(React.PureComponent);
_defineProperty(FocusHeroCarousel, "propTypes", {
  displayObject: T.node,
  items: T.array,
  nav: T.object,
  options: T.object,
  rtl: T.bool,
  theme: T.object
});
_defineProperty(FocusHeroCarousel, "defaultProps", {
  items: [],
  nav: {},
  options: {},
  rtl: false,
  theme: {}
});
export default withOnlyUpdateKeys(['items', 'options', 'prefix'])(FocusHeroCarousel);